import * as React from 'react';

import { localeData } from '../../locales/data';
import { getLanguageCode } from '../../shared/helpers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface PaginationResultsProps {
  pageSize: number;
  numOfResults: number;
  extraInfo?: {
    msg: string;
    values: any;
  };
  changePageSize?: any;
  handleKeyPress?: any;
  pageSizeLimit?: any;
}

export const PaginationResults = ({ pageSize, numOfResults, extraInfo = { msg: '', values: {} } }: PaginationResultsProps) => (
  <div className="pagination-footer__show">
    <FormattedMessageHelper
      tagName="span"
      id="pagination.show.results"
      defaultMessage={localeData.en['pagination.show.results']}
      values={{ pageSize: pageSize, numOfResults: numOfResults.toLocaleString(getLanguageCode()) }}
    />
    &nbsp;
    {extraInfo && (
      <FormattedMessageHelper tagName="span" id={extraInfo.msg} defaultMessage={localeData.en[extraInfo.msg]} values={extraInfo.values} />
    )}
  </div>
);
